import React, { useRef, useState, useEffect } from "react";
import EmployeeLayout from "../../../layout/EmployeeLayout";
import strings from '../../../translation';
import { useSelector, useDispatch } from "react-redux";
import ReactPlayer from 'react-player';
import SignatureCanvas from 'react-signature-canvas';
import './signatureStyle.css';
import { useLocation } from 'react-router-dom';
import Button from "../../../components/Button"
import { useHistory } from "react-router-dom"
const Quiz = () => {
  const videoRef = useRef(null);
  const signatureRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const [isVideoCompleted, setIsVideoCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [signatureURL, setSignatureURL] = useState(null);
  const user = useSelector(state => state.login.loginInfo)
  const dispatch = useDispatch();

  const [index, setIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);

  const [isFinished, setIsFinished] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null);

  const history = useHistory()

  const location = useLocation();
  const { id,meeting_id } = location.state || {}; 

  const quiz = useSelector(state => state.Quiz.quiz);
  const result = useSelector(state => state.Quiz.result);
  const attemptQuizRequesting = useSelector(state => state.Quiz.attemptQuizRequesting);
  const totalPoints = useSelector(state => state.Quiz.totalPoints);

  useEffect(() => { 
    if(attemptQuizRequesting){
      setLoading(false)
      setShowResult(true)
    }
  }, [attemptQuizRequesting]);

  useEffect(() => {
    dispatch({ type: "QUIZ", data:id, meeting_id });
  }, [meeting_id])

  useEffect(() => {
    if (quiz) {
      if(quiz?.message){
        history.push("/employee/dashboard")
      }else{
        const firstUnAnsweredIndex = quiz.findIndex(
          item => item.is_answered === false
        )
        if (firstUnAnsweredIndex == -1) {
          setIndex(quiz.length - 1);
        }else{
          setIndex(firstUnAnsweredIndex);
        }
      }
      
      
      
    }
  }, [quiz])

  const handleNext = () => {
    if(index!= null){
      if(selectedOption){
        setLoading(true)
        const payload = {
          question: quiz[index]["id"],
          options_list: [selectedOption.id]
        }
        dispatch({
          type: "ATTEMPT_QUIZ",
          data: payload,
          len: quiz.length,
          nextIndex: index + 1,
          callback: () => {
            setLoading(false)
            setSelectedOption(null)
            setIndex(index + 1);
          }
        })
      }
    }

  }

  const moveNext = () => {
    if(index == quiz.length - 1){
      setIsFinished(true)
      dispatch({ type: "QUIZ_FINISHED", data: { meeting_id: meeting_id, is_quiz_completed: true } })
    }else{
      setLoading(false)
      setShowResult(false)
      setIndex(index + 1);
    }
  }

  return (
    <EmployeeLayout isActive={strings.HOME}>
      <div className="company-home-section">
        <div className="page-title">{strings.QUIZ}</div>
        {!isFinished ? <div>
        {!showResult ? <div>
          {quiz && quiz.length > 0 ? (
            <div className="quiz-container">
              <h5>{strings.QUESTION} {index + 1}</h5>
              <div className="quiz-question" style={{marginTop:10}}>{quiz[index]?.question}</div>
              <div className="quiz-options" style={{ marginTop: 20,marginBottom: 25 }}>
                  {quiz[index]?.question_type == "Multiple Selections" ? (
                    <div>
                      {quiz[index]?.options.map((option, idx) => (
                        <div key={idx} className="jobsite-item" style={{display: "flex", justifyContent: "space-between", alignItems: "center",border: "1px solid #ccc", padding: "20px", borderRadius: "15px",marginTop: "20px",marginBottom:30 }}>
                          <div className="jobsite-name">{option.option}</div>
                          <div className="check-box">
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                onChange={() => {
                                  if (selectedOption && selectedOption === option.id) {
                                    setSelectedOption(null)
                                  }else{
                                    setSelectedOption(option)
                                  }
                                }}
                                checked={selectedOption && selectedOption.id === option.id}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                      </div>
                      ))}
                    </div>
                  ) : (
                    <div>
                      {quiz[index]?.options.map((option, idx) => (
                        <div key={idx} className="jobsite-item" style={{display: "flex", justifyContent: "space-between", alignItems: "center",border: "1px solid #ccc", padding: "20px", borderRadius: "15px",marginTop: "20px",marginBottom:30 }}>
                          <div className="jobsite-name">{option.option}</div>
                          <div className="check-box">
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                
                                onChange={() => {
                                  if (selectedOption && selectedOption === option.id) {
                                    setSelectedOption(null)
                                  }else{
                                    setSelectedOption(option)
                                  }
                                }}
                                checked={selectedOption && selectedOption.id === option.id}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                      </div>
                      ))}
                    </div>
                  )}
              </div>
              <Button
                className="board-btn sign-in-btn"
                showSpinner={loading}
                title={strings.NEXT}
                onClick={ () => {
                  handleNext()
                } }
              />
            </div>
          ) : (
            <p>{strings.NO_QUIZ_AVAILABLE}</p>
          )}
          </div> : <div>
              {result && <div className="quiz-container">
                <h5>{strings.QUESTION} {index + 1}</h5>
                {result?.answer[0].answer_options?.is_answer ? (
                  <div className="quiz-question" style={{marginTop:20,backgroundColor:'#FED200',padding:'10px 15px',borderRadius:10}}>{strings.YOUR_ANSWER_IS_CORRECT}</div>
                ) : (
                  <div className="quiz-question" style={{marginTop:20,backgroundColor:'#C7322E',padding:'10px 15px',borderRadius:10}}>{strings.YOUR_ANSWER_IS_INCORRECT}</div>
                )}
                <div style={{marginTop:50}}></div>
                <Button
                  className="board-btn sign-in-btn"
                  showSpinner={loading}
                  title={strings.NEXT}
                  onClick={ () => {
                     moveNext()
                  } }
              />
              </div>}
          </div>}
        </div> : <div>
          <div className="quiz-container">
            <h5>{strings.FINISHED}</h5>
            <div className="quiz-question" style={{marginTop:20,backgroundColor:'#FED200',padding:'10px 15px',borderRadius:10,fontWeight:600}}>{strings.TOTAL_POINTS} {totalPoints}</div>
            <div style={{marginTop:20}}>{strings.GREAT_JOB} {`${user?.users?.name}! `}</div>
            <div style={{marginTop:10}}>{strings.SEE_YOU_AT_THE_NEXT_SAFETY_MEETING}</div>
            <div style={{marginTop:50}}></div>
            <Button
              className="board-btn sign-in-btn"
              showSpinner={loading}
              title={strings.EXIT}
              onClick={ () => {
                history.push("/employee/dashboard")
              } }
            />
          </div>
        </div>}
      </div>
    </EmployeeLayout>
  );
};

export default Quiz;
